module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-12.1e283815.png";